module.exports = {
  // *** NOTE: Make an offer: Temporary redirection to Viktoria (status: disabled)
  // currentAgent: {
  //   name: 'Viktoria',
  //   email: 'viktoria@grayandsons.com',
  //   phone: '+17862664763'
  // },
  currentAgent: {
    name: 'Rich',
    email: 'info@grayandsons.com',
    phone: '+13057992523'
  }
}
